module.exports = __webpack_public_path__ + "media/react/features/event-creation-wizard/assets/templates/recruitment-b69d68ef95037ccb071a77071479178d.png";